import "./App.css";
import AstrologyReader from "./AstrologyReader";

function App() {
  return <AstrologyReader />;
}

export default App;
